// extracted by mini-css-extract-plugin
export default {"assets":"Assets_assets__SgNMu","assetsContent":"Assets_assetsContent__spsRU"};